/** Forms */
export const GET_FORMS = 'GET_FORMS';
export const GET_FORMS_SUCCESS = 'GET_FORMS_SUCCESS';
export const RESET_FORMS = 'RESET_FORMS';

export const GET_FORMS_DEFAULT = 'GET_FORMS_DEFAULT';
export const GET_FORMS_DEFAULT_SUCCESS = 'GET_FORMS_DEFAULT_SUCCESS';
export const RESET_FORMS_DEFAULT = 'RESET_FORMS_DEFAULT';

export const RESET_FORM_BY_ID = 'RESET_FORM_BY_ID';
export const GET_FORM_BY_ID = 'GET_FORM_BY_ID';
export const GET_FORM_BY_ID_SUCCESS = 'GET_FORM_BY_ID_SUCCESS';

export const GET_FORM_SETTINGS = 'GET_FORM_SETTINGS';
export const GET_FORM_SETTINGS_SUCCESS = 'GET_FORM_SETTINGS_SUCCESS';

export const CREATE_FORM = 'CREATE_FORM';
export const EDIT_FORM = 'EDIT_FORM';

export const DELETE_FORM = 'DELETE_FORM';
export const GET_CLIENT_INVITE_FORM = 'GET_CLIENT_INVITE_FORM';
export const GET_CLIENT_INVITE_FORM_SUCCESS = 'GET_CLIENT_INVITE_FORM_SUCCESS';
export const SAVE_INVITE_FORM = 'SAVE_INVITE_FORM';
export const RESEND_INVITE_FORM = 'RESEND_INVITE_FORM';
export const REQUEST_INVITE_FORM = 'REQUEST_INVITE_FORM';

export const CHANGE_FORM_STATUS = 'CHANGE_FORM_STATUS';

export const GET_CLIENT_FILED_FORM = 'GET_CLIENT_FILED_FORM';
export const GET_CLIENT_FILED_FORM_SUCCESS = 'GET_CLIENT_FILED_FORM_SUCCESS';
export const CLIENT_FORM_REVIEW = 'CLIENT_FORM_REVIEW';
